<div id="case-detailed-results" class="container-fluid pb-3">

    <case-results-readonly [idPrefix]="idPrefix" *permissions="[Permission.SMP_CASE_EDIT_ASSESSOR_SECTION]; logic: LogicOp.NAND"></case-results-readonly>

    <case-results-editable [idPrefix]="idPrefix" *permissions="[Permission.SMP_CASE_EDIT_ASSESSOR_SECTION]"></case-results-editable>

</div>
